import {
  Module, ActionTree, MutationTree, GetterTree
} from 'vuex';
import { readCookie, writeCookie } from '@/tools/tools';
import { HomeState } from './types';
import { RootState } from '../types';

/**
 * getters
 */
export const getters: GetterTree<HomeState, RootState> = {
  addresslist: (state: HomeState) => state.classifylist,
  smallImg: (state: HomeState) => state.smallImg
};

/**
 * mutations
 */
export const mutations: MutationTree<HomeState> = {
  // 分类列表获取
  ADDCLASSIFYLIST(state: HomeState, payload: []) {
    state.classifylist = payload;
    writeCookie('classifylist', state.classifylist);
  },
  // 获取限时抢购小图标
  ADDSMALLIMG(state: HomeState, payload: {}) {
    state.smallImg = payload;
  }
};

/**
 * actions
 */
export const actions: ActionTree<HomeState, RootState> = {
  setclassifylist({ commit }, payload:[]) {
    commit('ADDCLASSIFYLIST', payload);
  }
};
/**
 * state
 */
export const state: HomeState = {
  classifylist: readCookie('classifylist') ? readCookie('classifylist') : [],
  smallImg: {}
};
const namespaced: boolean = true;

export const home: Module<HomeState, RootState> = {
  namespaced,
  state,
  getters,
  mutations,
  actions
};
